import { useEffect } from 'react';
import dayjs from 'dayjs';

import type { Nullable } from 'Types/utils';

type Timeout = ReturnType<typeof setTimeout>;

interface UseCallbackOnTimeout {
	callback: () => void;
	condition: boolean;
	time: Nullable<string>;
}

const useCallbackOnTimeout = ({ callback, condition, time }: UseCallbackOnTimeout): void => {
	useEffect(() => {
		if (!time) {
			return undefined;
		}

		let timeout: Timeout;
		const ms = dayjs(time).diff(dayjs());
		if (condition && ms > 0) {
			timeout = setTimeout(() => callback(), ms);
		}

		return () => {
			clearTimeout(timeout);
		};
	}, [condition, time, callback]);
};

export default useCallbackOnTimeout;
